//------------- REACT IMPORT ---------------//
import React, { useEffect, useState } from "react";
//---------- FONTAWESOME IMPORT ------------//
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleDown,
    faBed,
    faCalendarWeek,
    faCircleCheck,
    faHospital,
    faHouse,
    faImage,
    faUser,
    faVenus,
} from "@fortawesome/free-solid-svg-icons";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
//------------ CONSTANTS IMPORT ------------//
import * as Constants from "../../../../Helper/constants/constants";
import { Building, Check, Hospital_Banner, Loc, Loc_Round, Profile_hos, Route } from "../../../../../assets/images";
import TaskAssignModal from "../../../Modals/TaskAssignModal";
import HospitalDetailFunctions from "./funstions";


const HospitalDetails = () => {
    const {
        getHospitalDetail,
        hospitalDetail,
        loaction,
        navigate,
        taskAssign,
        setTaskAssign,
        breadcrumData,
        breadcrumItem
    } = HospitalDetailFunctions();


    useEffect(() => {
        if (loaction && loaction.state && loaction.state.id) {
            getHospitalDetail(loaction.state.id);
        }
        else {
            navigate(-1);
        }
    }, []);

    
    return (
        <div className="hospital_detail_area">
            <WithoutImageHeader
                header={Constants.HOSPITAL_DETAILS}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                icon={"edit"}
                handleNavigate={() => navigate('/add-hospital', { state: { id: hospitalDetail.id, name: 'EditHospital' } })}
            />
            {
                hospitalDetail ?
                    <div className="hospital_area">
                        <div className="img_banner">
                            <Image src={Hospital_Banner} alt="..." />
                        </div>
                        <div className="content_section">
                            {
                                hospitalDetail.name ?
                                    <div className="content_area">
                                        <div className="left_area">
                                            <div className="icon_user">
                                                <Image src={Profile_hos} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p style={{textTransform : "capitalize"}}>Name - {hospitalDetail.name}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                hospitalDetail.gst_number ?
                                    <div className="content_area">
                                        <div className="left_area">
                                            <div className="icon_user">
                                                <Image src={Check} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p>GSTIN - {hospitalDetail.gst_number}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                hospitalDetail.address ?
                                    <div className="content_area">
                                        <div className="left_area">
                                            <div className="icon_user">
                                                <Image src={Loc} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p style={{textTransform : "capitalize"}}>Address - {hospitalDetail.address}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                hospitalDetail.city ?
                                    <div className="content_area">
                                        <div className="left_area">
                                            <div className="icon_user">
                                                <Image src={Building} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p style={{textTransform : "capitalize"}}>City - {hospitalDetail.city}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                hospitalDetail.state ?
                                    <div className="content_area">
                                        <div className="left_area">
                                            <div className="icon_user">
                                                <Image src={Loc_Round} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p style={{textTransform : "capitalize"}}>State - {hospitalDetail.state}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                            {
                                hospitalDetail.zipcode ?
                                    <div className="content_area">
                                        <div className="left_area">
                                            <div className="icon_user">
                                                <Image src={Route} alt="..." />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <p>ZIP Code - {hospitalDetail.zipcode}</p>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                    </div>
                    :
                    null
            }
            {/* <TaskAssignModal show={taskAssign} close={() => setTaskAssign(false)} /> */}
        </div >
    );
};

export default HospitalDetails;
